var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1C3.34688 1 1.5 2.84688 1.5 5.125C1.5 9.25 6.375 13 9 13.8722C11.625 13 16.5 9.25 16.5 5.125C16.5 2.84688 14.6531 1 12.375 1C10.98 1 9.74625 1.69263 9 2.75275C8.61956 2.21102 8.11423 1.7689 7.52676 1.46381C6.93929 1.15872 6.28697 0.999627 5.625 1Z",
    fill: "#034A73",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled_heart.3c55a8299b6bd0cc31e1df175a91f0b2.svg";
export { ForwardRef as ReactComponent };